@let modules = (this.modules$ | async) ?? [];

<nav class="sidebar" [class.collapsed]="isSidebarCollapsed()">
  <div class="sidebar-brand">
    <a class="brand-link" routerLink="/" draggable="false">
      <img class="brand-logo" src="assets/images/logo.png" alt="logo"/>
      <span class="brand-text" translate>LOGO_COMPANY_ALT</span>
    </a>
  </div>

  <div class="sidebar-scroll">

    @for (module of modules; track module.id) {
      @if (module.menus.length > 0) {


        @if (module.menus.length === 1) {
          <!-- direct top-level link (no children) -->
          <a
            class="module-link"
            [routerLink]="module.menus[0].route"
            [class.active]="isMenuActive(module.id, module.menus[0].id)"
            draggable="false"
            [title]="module.menus[0].name"
          >
            <i class="module-icon mdi mdi-{{ module.icon }}"></i>

          @if (!isSidebarCollapsed()) {
            <span class="module-label" translate>{{ module.menus[0].name }}</span>
          }
          </a>
        } @else {
          <div class="module-block">
            <button
              type="button"
              class="module-link"
              [class.active]="isSidebarCollapsed() && activeModuleId() === module.id"
              (click)="onModuleClick(module.id)"
              [title]="module.name"
            >
              <i class="module-icon mdi mdi-{{ module.icon }}"></i>

              @if (!isSidebarCollapsed()) {
                <span class="module-label" translate>{{ module.name }}</span>
                <i
                  class="submenu-caret mdi"
                  [class.mdi-chevron-down]="isParentMenuCollapsed().get(module.id)"
                  [class.mdi-chevron-right]="!isParentMenuCollapsed().get(module.id)"
                ></i>
              }

            </button>

            @if (!!isParentMenuCollapsed().get(module.id)) {
              <div class="submenu">
                @for (menu of module.menus; track menu.id) {
                  @if (!menu.children || menu.children.length === 0) {
                    <a
                      class="submenu-item"
                      draggable="false"
                      [routerLink]="menu.route"
                      [class.active]="isMenuActive(module.id, menu.id)"
                    >
                      @if (menu.icon) {
                        <i class="submenu-icon mdi mdi-{{ menu.icon }}"></i>
                      }
                      <span class="submenu-text" translate>{{ menu.name }}</span>
                    </a>
                  } @else {
                    <button
                      type="button"
                      class="submenu-group"
                      [class.active]="isGroupActiveCollapsed(module.id, menu.id)"
                      (click)="onMenuClick(module.id, menu.id)"
                    >
                      @if (menu.icon) {
                        <i class="submenu-icon mdi mdi-{{ menu.icon }}"></i>
                      }
                      <span class="submenu-text" translate>{{ menu.name }}</span>
                      <i
                        class="submenu-caret mdi"
                        [class.mdi-chevron-down]="isParentMenuCollapsed().get(module.id + menu.id.toString())"
                        [class.mdi-chevron-right]="!isParentMenuCollapsed().get(module.id + menu.id.toString())"
                      ></i>
                    </button>
                    @if (!!isParentMenuCollapsed().get(module.id + menu.id.toString())) {
                      @for (child of menu.children; track child.id) {
                        <a
                          class="submenu-item submenu-item-nested"
                          [routerLink]="child.route"
                          [class.active]="isMenuActive(module.id, child.id)"
                        >
                          @if (child.icon) {
                            <i class="submenu-icon mdi mdi-{{ child.icon }}"></i>
                          }
                          <span class="submenu-text">{{ child.name }}</span>
                        </a>
                      }
                    }
                  }
                }
              </div>
            }
          </div>
        }
      }
    }
  </div>

  <div class="sidebar-footer">
    <button
      type="button"
      class="module-link"
      (click)="onSidebarToggle()"
      [title]="(isSidebarCollapsed() ? 'SIDEBAR_TOOLTIP_EXPAND' : 'SIDEBAR_TOOLTIP_COLLAPSE') | translate"
    >
      <i
        class="module-icon mdi "
        [class.mdi-chevron-double-left]="!isSidebarCollapsed()"
        [class.mdi-chevron-double-right]="isSidebarCollapsed()"
      ></i>
      <span class="module-label">{{
          "SIDEBAR_TOOLTIP_COLLAPSE" | translate
        }}</span>
    </button>
    <button
      type="button"
      class="module-link"
      (click)="changePassword()"
      [title]="'HEADER_LBL_CHANGE_PASSWORD' | translate"
    >
      <i class="module-icon mdi mdi-lock-outline"></i>
      <span class="module-label">{{
          "HEADER_LBL_CHANGE_PASSWORD" | translate
        }}</span>
    </button>
    <button
      type="button"
      class="module-link"
      (click)="logout()"
      [title]="'HEADER_LBL_LOG_OFF' | translate"
    >
      <i class="module-icon mdi mdi-logout"></i>
      <span class="module-label">{{ "HEADER_LBL_LOG_OFF" | translate }}</span>
    </button>
  </div>
</nav>
